import { type ReactNode } from 'react'
import { useLocation } from 'react-router-dom'
import Header from './Header'
import Footer from './Footer'

interface LayoutProps {
  children: ReactNode
}

// The rainbow band ends halfway between the トップページ search box and the first carousel title (below
// 現在の宿題 and 探究・相談しよう!); every student page shares the same height.
const GRADIENT_HEIGHT = 427

const Layout = ({ children }: LayoutProps) => {
  const location = useLocation()
  const teacherModeParam = new URLSearchParams(location.search).get('teacherMode') === 'true'
  const isTeacherMode = location.pathname === '/teacher' || location.pathname.startsWith('/teacher/') || teacherModeParam

  return (
    <div className="min-h-screen bg-gray-50">
      {!isTeacherMode && (
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-screen bg-gradient-to-r from-[#F472B6] via-[#FBBF24] via-[#FB923C] to-[#5EEAD4]" style={{ height: GRADIENT_HEIGHT }} />
      )}
      <div className="relative">
        <Header />
        {isTeacherMode && (
          <div className="w-full h-2 bg-[#0075ff]" />
        )}
        <main className="flex-1">
          {children}
        </main>
        <Footer />
      </div>
    </div>
  )
}

export default Layout
